import type { NestUserRole } from '@/types/user'

/**
 * Checks the role in the stored JWT token. The API enforces the same role, so this only decides what is shown.
 */
export function hasJwtRole(role: NestUserRole): boolean {
  const token = localStorage.getItem('jwt_token')

  return token != null && parseJwt(token)?.['role'] === role
}

export function parseJwt(token: string) {
  try {
    const base64Url = token.split('.')[1]
    if (!base64Url) return null

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(char => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )

    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Invalid JWT token', error)
    return null
  }
}
